export const environment = {
  production: true,

  newServiceUrl:'https://stratgist.com/MasterProjectByte/MasterProjectByte/',
  hostUrl: 'https://stratgist.com/MasterProjectByte',
  imagePath: 'https://stratgist.com/MasterProjectByte/ModuleImage',
  summaryPath: 'https://stratgist.com/MasterProjectByte/ModuleSummary',
  serviceUrl: 'http://www.happcoach.com/PilotServices/ProjectByte/',
  happCoachUrl: 'http://www.happcoach.com',
  paymentUrl:"https://stratgist.com/MasterProjectBytePayment/?Paymentid=",
  footer40:false
};



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/environments/environment.prod.ts